// Collection Request Types
export interface CollectionRequest {
  id: number;
  user_id: number;
  waste_type: WasteType;
  description: string;
  estimated_weight?: number;
  estimated_volume?: number;
  collection_address: string;
  collection_date?: string;
  collection_time_preference?: string;
  status: CollectionStatus;
  urgency: UrgencyLevel;
  special_instructions?: string;
  contact_phone?: string;
  is_recurring: boolean;
  assigned_collector_id?: number;
  actual_collection_date?: string;
  actual_weight?: number;
  completion_notes?: string;
  created_at: string;
  updated_at: string;
  assigned_at?: string;
  completed_at?: string;
  cancelled_at?: string;
  cancellation_reason?: string;
}

export interface CollectionRequestSummary {
  id: number;
  waste_type: WasteType;
  description: string;
  collection_address: string;
  collection_date?: string;
  status: CollectionStatus;
  urgency: UrgencyLevel;
  created_at: string;
}

export interface CollectionRequestListResponse {
  items: CollectionRequestSummary[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export interface CreateCollectionRequest {
  waste_type?: WasteType;
  description: string;
  estimated_weight?: number;
  estimated_volume?: number;
  collection_address: string;
  collection_date?: string;
  collection_time_preference?: string;
  urgency?: UrgencyLevel;
  special_instructions?: string;
  contact_phone?: string;
  is_recurring?: boolean;
}

// Collector Types
export interface Collector {
  id: number;
  user_id: number;
  employee_id: string;
  phone: string;
  vehicle_number?: string;
  vehicle_type?: string;
  license_number?: string;
  work_area?: string;
  max_capacity: number;
  current_load: number;
  status: CollectorStatus;
  is_available: boolean;
  current_latitude?: number;
  current_longitude?: number;
  last_location_update?: string;
  total_collections: number;
  total_weight_collected: number;
  rating: number;
  rating_count: number;
  notes?: string;
  emergency_contact?: string;
  work_start_time?: string;
  work_end_time?: string;
  created_at: string;
  updated_at: string;
}

export interface CollectorSummary {
  id: number;
  employee_id: string;
  phone: string;
  work_area?: string;
  status: CollectorStatus;
  is_available: boolean;
  current_load: number;
  max_capacity: number;
  rating: number;
  total_collections: number;
}

export interface CollectorDashboard {
  collector_info: Collector;
  assigned_requests_count: number;
  pending_requests_count: number;
  completed_today: number;
  total_weight_today: number;
  current_capacity_usage: number;
}

export interface CreateCollector {
  employee_id: string;
  phone: string;
  vehicle_number?: string;
  vehicle_type?: string;
  license_number?: string;
  work_area?: string;
  max_capacity?: number;
  work_start_time?: string;
  work_end_time?: string;
  emergency_contact?: string;
  notes?: string;
}

// Enum Types
export enum WasteType {
  FOOD = 'food'
}

export enum CollectionStatus {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled'
}

export enum UrgencyLevel {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  URGENT = 'urgent'
}

export enum CollectorStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ON_DUTY = 'on_duty',
  OFF_DUTY = 'off_duty',
  UNAVAILABLE = 'unavailable'
}

// Filter Types
export interface CollectionRequestFilter {
  page?: number;
  size?: number;
  waste_type?: WasteType;
  status?: CollectionStatus;
  urgency?: UrgencyLevel;
}

export interface CollectorFilter {
  skip?: number;
  limit?: number;
  status?: CollectorStatus;
  is_available?: boolean;
}

// Status Labels
export const CollectionStatusLabels = {
  [CollectionStatus.PENDING]: '대기중',
  [CollectionStatus.CONFIRMED]: '확정됨',
  [CollectionStatus.IN_PROGRESS]: '진행중',
  [CollectionStatus.COMPLETED]: '완료',
  [CollectionStatus.CANCELLED]: '취소됨'
};

export const UrgencyLevelLabels = {
  [UrgencyLevel.LOW]: '낮음',
  [UrgencyLevel.MEDIUM]: '보통',
  [UrgencyLevel.HIGH]: '높음',
  [UrgencyLevel.URGENT]: '긴급'
};

export const CollectorStatusLabels = {
  [CollectorStatus.ACTIVE]: '활성화',
  [CollectorStatus.INACTIVE]: '비활성화',
  [CollectorStatus.ON_DUTY]: '근무중',
  [CollectorStatus.OFF_DUTY]: '근무종료',
  [CollectorStatus.UNAVAILABLE]: '사용불가'
};

export const WasteTypeLabels = {
  [WasteType.FOOD]: '음식물쓰레기'
};